/* eslint-disable */
import FolderList from '@/components/probaworkflows_base_components/FolderList/FolderList.vue';
import NavigationBackButton from '@/components/probaworkflows_base_components/NavigationBackButton/NavigationBackButton.vue';
import RenderSections from '@/components/probaworkflows_base_components/RenderMainSections/RenderMainSections.vue';
import {
  ADMIN_VERIFY_APPLICATION_URL,
  APPROVED,
  ASSIGN_TRUST_ADMIN,
  CREATE_ENTITY_APPLICATION_ONLY,
  ENTITY_REGISTER,
  GET_ENTITY_TYPE_FORMS,
  GET_ASSIGNED_WIDGETS,
  get_headers,
  GET_TABS,
  get_token,
  get_user_role,
  LIST_ASSIGNED_CHILD_ENTITY_TYPES_URL,
  NOT_APPROVED,
  ROLES_URL,
  USER_LIST_URLS,
  get_project_id,
} from '@/utils/constants/constants';
import ApplicationLog from "@/views/probaworkflows_base/management/trust_applications/application_log/ApplicationLog.vue";
import alert_mixin from '@/utils/mixins/alert_mixin';
import formatting_mixins from '@/utils/mixins/formatting_mixins';
import { sub_entities_mixin } from '@/utils/mixins/sub_entities_mixin';
import { validate_email } from '@/utils/validations/validate_inputs';
import ViewComplianceChecks from '@/views/probaworkflows_base/management/compliance_management/view_compliance_checks/ViewComplianceChecks.vue';
import ESigning from '@/views/probaworkflows_base/management/template_managment/e_signing/ESigning.vue';
import ApplicationAssignment from '@/views/probaworkflows_base/management/trust_applications/application_assignment/ApplicationAssignment.vue';
import ApplicationAttributes from '@/views/probaworkflows_base/management/trust_applications/application_attributes/ApplicationAttributes.vue';
import ApplicationJournal from '@/views/probaworkflows_base/management/trust_applications/application_journal/ApplicationJournal.vue';
import ApplicationVerification from '@/views/probaworkflows_base/management/trust_applications/application_verification/ApplicationVerification.vue';
import DocumentManagement from '@/views/probaworkflows_base/management/trust_applications/document_management/DocumentManagement.vue';
import ProgressTracker from '@/views/probaworkflows_base/management/trust_applications/progress_tracker/ProgressTracker.vue';
import VerificationOverview from '@/views/probaworkflows_base/management/trust_applications/verification_managment/verification_overview/VerificationOverview.vue';
import axios from 'axios';
import ViewRequests from '../view_requested_information/view_requests/ViewRequests.vue';

export default {
  name: 'OverviewOfProfile',
  mixins: [alert_mixin, formatting_mixins, sub_entities_mixin],
  components: {
    ProgressTracker,
    ApplicationVerification,
    VerificationOverview,
    ESigning,
    NavigationBackButton,
    ViewComplianceChecks,
    DocumentManagement,
    RenderSections,
    ViewRequests,
    ApplicationAssignment,
    ApplicationJournal,
    ApplicationAttributes,
    FolderList,
    ApplicationLog
  },
  data: () => ({
      entity_name: "",
      application_status: "",
      application_id: null,
      entity_profile_id: null,
      user_role: null,
      form_id: null,
      role_id: null,
      user_id: null,
      application_form_id: null,
      profile_role_id: null,
      show_log_modal: false,
      active_tab: null,
      selected_dropdown: null,
      loading_more_tabs: false,
      token: get_token(),
      headers: get_headers(),
      entity_id: '',
      users: [],
      system_admins: [],
      users_list: [],
      user_roles: [],
      table_headers: [],
      error_message: '',
      assigned_admin: null,
      all_forms: [],
      assigned_tabs: [],
      form_tab_mapping: {},
      all_tabs: [],
      visible_tabs: [],
      dropdown_options: {},
      show_dropdown: false,
      selected_admin: '',
      temp_selected: '',
      tabs: [],
      tabs_loading: false,
      tabs_error: null,
      database_tabs: [],
      active_form_main_section_id: null,
      status_approved: APPROVED,
      status_not_approved: NOT_APPROVED,
      pending_applications_list: [],
      LIST_SUB_ENTITIES_BY_PARENT_APPLICATION: 'LIST_SUB_ENTITIES_BY_PARENT_APPLICATION',
      is_verifying: false,
      current_entity: null,
      entity_type_id: null,
      is_loading_sub_entity: false,
      current_form: {
        parent_id: null,
        parent_name: '',
        child_id: '',
        parent_application_id: '',
        parent_entity_profile_id: '',
      },
      assign_sub_entity_type_id: '',
      assign_sub_entity_options: [],
      assign_form_list: [],
      assign_selected_form_id: '',
      assign_entity_name: '',
      assign_email: '',
      include_email: false,
      project_id: null,
      is_saving: false,
      validation_error: null,
      is_loading_options: false,
      trust_number: "",
  }),
  watch: {
    '$route.query': {
      immediate: true,
      deep: true,
      handler(newQuery, oldQuery) {
        const new_app_id = newQuery.application_id ? Number(newQuery.application_id) : null;
        const new_entity_profile_id = newQuery.entity_profile_id ? Number(newQuery.entity_profile_id) : null;
        const old_app_id = oldQuery?.application_id ? Number(oldQuery.application_id) : null;
        const old_entity_profile_id = oldQuery?.entity_profile_id ? Number(oldQuery.entity_profile_id) : null;

        if (new_app_id !== old_app_id || new_entity_profile_id !== old_entity_profile_id) {
          this.reload_component_data();
        } else {
          this.update_data_from_route();
        }
      }
    }
  },
  computed: {
    forms_for_active_tab() {
      if (!this.active_tab || !this.all_forms) return [];
      const form_names = this.form_tab_mapping[this.active_tab] || [];
      return this.all_forms.filter(form => form_names.includes(form.name));
    },
    active_tab_has_forms() {
      return this.forms_for_active_tab?.length > 0;
    },
    active_tab_has_dropdown() {
      const tab = this.visible_tabs.find(t => t.id === this.active_tab);
      return tab?.has_dropdown || false;
    },
    active_tab_dropdown_options() {
      return this.dropdown_options[this.active_tab] || [];
    },
    active_tab_details() {
      return this.visible_tabs.find(tab => tab.id === this.active_tab) || {};
    },
    has_assigned_admin() {
      return this.assigned_admin !== null;
    },
    assigned_admin_name() {
      if (this.assigned_admin) {
        if (this.assigned_admin.full_name) {
          return this.assigned_admin.full_name;
        }
        return `${this.assigned_admin.first_name || ''} ${this.assigned_admin.last_name || ''}`.trim();
      }
      return '';
    },
    has_sub_entities() {
      return this.displayed_applications_list && this.displayed_applications_list.length > 0;
    },
    is_hierarchy_loading() {
      return this.is_hierarchy_loading;
    },
    get_entity_type_id() {
      const from_route = this.$route?.query?.entity_type_id ?? null;
      const value = from_route ?? sessionStorage.getItem('entity_type_id') ?? null;

      if (from_route != null) sessionStorage.setItem('entity_type_id', String(from_route));

      const num = Number(value);
      return Number.isFinite(num) ? num : (value ?? null);
    },
    is_master_registered() {
    return this.application_status.toLowerCase().includes('master registered');
  },
   display_trust_number() {
        return this.trust_number || 
               this.$route.query.trust_number || 
               sessionStorage.getItem('trust_number') || 
               '';
    },
  },
  methods: {

    handle_status_updated(payload) {
    this.application_status = payload.formatted_status;
    sessionStorage.setItem('application_status', payload.status);
    if (payload.trust_number) {
        this.trust_number = payload.trust_number;
        this.$router.replace({
            query: {
                ...this.$route.query,
                trust_number: payload.trust_number,
                status: payload.status
            }
        });
        
        sessionStorage.setItem('trust_number', payload.trust_number);
    } else {
        this.$router.replace({
            query: {
                ...this.$route.query,
                status: payload.status
            }
        });
    }
    
    this.selected_log_status = payload.formatted_status;
},

   normalize_item(item) {
      const is_child = Boolean(item?.is_child);
      return ({
        is_child,
        type_id: Number(
          item?.type_id ??
          item?.entity_type_id ??
          item?._child_raw?.entity_type_id ??
          0
        ),
        application_id: Number(
          item?.["Application No"] ??
          item?.application_id ??
          item?._child_raw?.forms?.[0]?.application_id ??
          0
        ),
        entity_profile_id: Number(
          is_child
            ? (item?.id ?? item?.entity_profile_id ?? 0)
            : (item?.entity_profile_id ?? item?.id ?? 0)
        ),
        entity_type_name:
          item?.["Entity Type"] ??
          item?.entity_type_name ??
          item?._child_raw?.entity_type_name ??
          "Entity"
      });
    },

    async prepare_assign_modal(item) {      
      if (!item) {
        this.show_error('No entity selected. Please try again.');
        return false; // Return false to prevent modal opening
      }
      
      const normalize = this.normalize_item(item);
      if (!normalize.type_id || normalize.type_id === 0) {
        return false; // Prevent modal from opening
      }
      // Set current form data
      this.current_form.parent_id = normalize.type_id;
      this.current_form.parent_name = normalize.entity_type_name || "Entity";
      this.current_form.parent_application_id = normalize.application_id || this.application_id;
      this.current_form.parent_entity_profile_id = normalize.entity_profile_id || this.entity_profile_id;

      // Reset form fields
      this.assign_sub_entity_type_id = "";
      this.assign_form_list = [];
      this.assign_selected_form_id = "";
      this.assign_entity_name = "";
      this.assign_email = "";
      this.include_email = false;
      this.validation_error = null;
      this.is_saving = false;
      this.is_loading_options = true;

      try {
        // Load available sub-entity options
        const assigned_rows = await this.get_assigned_children(this.current_form.parent_id);
        this.assign_sub_entity_options = (assigned_rows || []).map(r => ({
          id: Number(r.child_entity_type_id),
          name: r.child_entity_type_name || "Unnamed",
        }));
        
        // Wait for Vue to update the DOM
        await this.$nextTick();
        // Return true to allow Bootstrap modal to open
        return true;
        
      } catch (error) {
        this.show_error('Failed to load sub-entity options: ' + error.message);
        return false; // Prevent modal from opening on error
      } finally {
        this.is_loading_options = false;
      }
    },

    handle_folderlist_add(item) {
      // Prepare the modal data first
      this.prepare_assign_modal(item).then(success => {
        if (!success) return;

        // After preparing data, manually trigger the modal
        this.$nextTick(() => {
          const modalElement = document.getElementById('assign_sub_entity_modal');
          if (!modalElement) return;

          new bootstrap.Modal(modalElement).show();
        });
      });
    },

    get_assigned_children(parent_entity_type_id) {      
      if (!parent_entity_type_id || parent_entity_type_id === 0) return [];
      
      return axios.get(
        LIST_ASSIGNED_CHILD_ENTITY_TYPES_URL,
        {
          headers: this.headers,
          params: { parent_entity_type_id },
        }
      )
      .then(res => {
        if (res.data?.status !== 'success') return [];

        const payload = res.data?.data;
        const result = Array.isArray(payload)
          ? payload
          : payload?.assigned_children || [];
        
        return result;
      })
      .catch(error => {
        this.show_error('Error fetching assigned children:', error);
        return [];
      });
    },

    async assign_on_sub_entity_change() {      
      this.assign_form_list = [];
      this.assign_selected_form_id = '';

      const entity_type_id = Number(this.assign_sub_entity_type_id || 0);
      if (!entity_type_id) {
        return;
      }

      try {
        const res = await axios.get(GET_ENTITY_TYPE_FORMS, {
          headers: this.headers,
          params: { entity_type_id }
        });
        
        const data = typeof res.data === 'string' ? JSON.parse(res.data) : res.data;
        this.assign_form_list = Array.isArray(data?.data) ? data.data : [];

      } catch (error) {
        this.show_error('Error getting forms:', error);
      }
    },

    async save_assign_sub_entity() {      
      // Clear previous validation errors
      this.validation_error = null;
      this.is_saving = true;
      
      try {
        // Validation checks
        if (!this.current_form?.parent_application_id) {
          this.validation_error = "Missing parent application.";
        }

        const child_type_id = Number(this.assign_sub_entity_type_id || 0);
        if (!child_type_id) {
          this.validation_error = "Please select a sub-entity type.";
        }

        const selected_form_id = Number(this.assign_selected_form_id || 0);
        if (!selected_form_id) {
          this.validation_error = "Please select a form for the sub-entity.";
        }

        const entity_name = (this.assign_entity_name || "").trim();
        if (!entity_name) {
          this.validation_error = "Please enter the sub-entity name.";
        }

        let email = null;
        if (this.include_email) {
          email = (this.assign_email || "").trim();
          if (!email || !validate_email(email)) {
            this.validation_error = "Please enter a valid email address.";
          }
        }

        // Get project_id
        const project_id = get_project_id() || this.$route.params.project_id || this.$route.query.project_id;

        if (!project_id) {
          return;
        }

        // Prepare payload
        const payload = {
          parent_application_id: Number(this.current_form.parent_application_id),
          entity_type_id: child_type_id,
          parent_entity_type_id: Number(this.current_form.parent_id),
          parent_entity_profile_id: Number(this.current_form.parent_entity_profile_id),
          project_id: Number(project_id),
          form_ids: [selected_form_id],
          entity_name: entity_name,
          ...(this.include_email && { email }),
        };

        // Determine which API to use based on email inclusion
        const api_url = this.include_email ? ENTITY_REGISTER : CREATE_ENTITY_APPLICATION_ONLY;

        // Make API call
        const resp = await axios.post(api_url, payload, { headers: this.headers });

        let response_data;

        // Parse response based on API type
        if (this.include_email) {
          response_data = JSON.parse(resp.data);
        } else {
          response_data = resp.data;
        }

        if (response_data?.status !== "success") {
          const error_msg = response_data?.message || "Failed to assign sub-entity.";
          this.validation_error = error_msg;
        }

        // Success handling
        this.show_success("Sub-entity added successfully!");

        this.assign_sub_entity_type_id = "";
        this.assign_form_list = [];
        this.assign_selected_form_id = "";
        this.assign_entity_name = "";
        this.assign_email = "";
        this.include_email = false;
        this.validation_error = null;

        // Close modal using Bootstrap
        const modalElement = document.getElementById('assign_sub_entity_modal');
        if (modalElement) {
          const modal = bootstrap.Modal.getInstance(modalElement);
          if (modal) {
            modal.hide();
          }
        }

        await this.load_sub_entities();

      } catch (error) {
        const msg = error?.response?.data?.message || error.message ||
          "Error assigning the sub-entity.";
        this.validation_error = msg;
        this.show_error(msg);
      } finally {
        this.is_saving = false;
      }
    },

    // Other Methods (keep existing)
    update_data_from_route() {
      const query = this.$route.query;
      this.application_id = query.application_id ? Number(query.application_id) : null;
      this.entity_profile_id = query.entity_profile_id ? Number(query.entity_profile_id) : null;
      this.entity_type_id = query.entity_type_id ? Number(query.entity_type_id) : null;
      this.entity_name = query.entity_name || "";
      const raw_status = query.status || "";
      this.application_status = raw_status ? this.format_question_type(raw_status) : "";
      this.current_entity = {
        type_id: this.entity_type_id,
        entity_type_name: this.entity_name,
        application_id: this.application_id,
        entity_profile_id: this.entity_profile_id,
        is_child: false
      };
      this.trust_number = query.trust_number || "";
    },

    async reload_component_data() {
      const loader = await this.show_loader("Loading application data...");

      try {
        this.update_data_from_route();
      } catch (error) {
        this.show_error('Error loading application data: ' + error.message);
      } finally {
        this.close_loader(loader);
      }
    },

    redirect_to_application_overview(row) {
      this.show_loader("Loading sub-entity profile...")
        .then(loader => {
          const application_id = Number(row["Application No"] ?? row.application_id ?? row.id);
          if (!application_id) {
            this.show_error("Unable to find application data");
            this.close_loader(loader);
            return;
          }

          const entity_profile_id = row.entity_profile_id ?? row.entity ?? null;
          const entity_type_id = row.entity_type_id ?? row.type_id ?? row.entity_type?.id ?? null;
          const entity_name = row["Entity Name"] ?? row.entity_name ?? "Unknown Entity";
          const status = row.Status ?? row.status?.status ?? row.status ?? "";

          sessionStorage.removeItem("application_id");
          sessionStorage.removeItem("application_status");
          sessionStorage.removeItem("entity_name");
          sessionStorage.removeItem("entity_profile_id");
          sessionStorage.removeItem("entity_type_id");

          sessionStorage.setItem("application_id", application_id.toString());
          sessionStorage.setItem("application_status", status);
          sessionStorage.setItem("entity_name", entity_name);

          if (entity_profile_id != null) {
            sessionStorage.setItem("entity_profile_id", entity_profile_id.toString());
          }

          if (entity_type_id != null) {
            sessionStorage.setItem("entity_type_id", entity_type_id.toString());
          }

          const query_params = {
            application_id: application_id.toString(),
            status: status,
            entity_name: entity_name,
            ...(entity_profile_id != null && { entity_profile_id: entity_profile_id.toString() }),
            ...(entity_type_id != null && { entity_type_id: entity_type_id.toString() }),
          };

          this.$router.push({
            path: "/overview_of_profile",
            query: query_params,
          });

          setTimeout(() => {
            this.close_loader(loader);
          }, 500);
        })
        .catch(error => {
          this.show_error("Error loading sub-entity profile");
        });
    },

    get_backend_filter_from_status(status) {
      const status_map = {
        'in-progress': 'In_Progress',
        'approved': 'Approved',
        'submitted': 'Submitted',
        'not approved': 'Not_Approved',
        'awaiting verification': 'Awaiting_Verification'
      };
      return status_map[status] || status;
    },

    open_assign_modal(item) {
      // For backward compatibility
      this.prepare_assign_modal(item).then(success => {
        if (success) {
          this.$nextTick(() => {
            const modalElement = document.getElementById('assign_sub_entity_modal');
            if (modalElement) {
              const modal = new bootstrap.Modal(modalElement);
              modal.show();
            }
          });
        }
      });
    },

    open_log_modal() {

      this.user_id = this.$route.query.user_id || null;
      

      this.selected_log_status = this.$route.query.status || null;

      this.show_log_modal = true;
    },

    close_log_modal() {
      this.show_log_modal = false;
    },
    async load_sub_entities() {
      if (!this.application_id) return;

      try {
        await this.load_full_hierarchy();
      } catch (error) {
        this.show_error('Failed to load sub-entities');
      }
    },

    get_application_id() {
      const from_route = this.$route?.query?.application_id ?? null;
      const value = from_route ?? sessionStorage.getItem('application_id') ?? null;

      if (from_route != null) sessionStorage.setItem('application_id', String(from_route));

      const num = Number(value);
      return Number.isFinite(num) ? num : (value ?? null);
    },

    get_entity_profile_id() {
      const from_route = this.$route?.query?.entity_profile_id ?? null;
      const value = from_route ?? sessionStorage.getItem('entity_profile_id') ?? null;

      if (from_route != null) sessionStorage.setItem('entity_profile_id', String(from_route));

      const num = Number(value);
      return Number.isFinite(num) ? num : (value ?? null);
    },

    is_db_main_section_tab(tabId) {
      return typeof tabId === 'string' && tabId.startsWith('ms-');
    },

    fetch_assigned_widgets() {
      const request_params = {
        entity_profile_id: this.entity_profile_id,
      };

      return axios
        .get(GET_ASSIGNED_WIDGETS, {
          params: request_params,
          headers: this.headers,
        })
        .then(({ data }) => {
          this.all_tabs = data.map(item => ({
            id: item.widget.widget_name,
            name: item.widget.widget_display_name,
            has_dropdown: true,
          }));

          this.dropdown_options = Object.fromEntries(
            data.map(item => [
              item.widget.widget_name,
              [{ value: item.widget.widget_name, label: item.widget.widget_display_name }]
            ])
          );

          this.assigned_tabs = [...this.all_tabs];
          this.visible_tabs = this.assigned_tabs
        })
        .catch(error => {
          const message =
            error?.response?.data?.message ||
            error.message ||
            "Failed to load widgets";
          this.show_error(message);
        });
    },

    fetch_main_section_tabs() {
      const request_params = {
        application_id: this.application_id,
        entity_profile_id: this.entity_profile_id,
      };
      return axios
        .get(GET_TABS, { params: request_params, headers: this.headers })
        .then(({ data }) => {
          this.application_form_id = data.data.application_form_id
          if (this.application_form_id != null) {
            sessionStorage.setItem('application_form_id', String(this.application_form_id));
          }

          const rows = Array.isArray(data?.data.data) ? data.data.data : [];

          const dynamic_tabs = rows.map((row) => ({
            id: `ms-${row.id}`,
            name: row.name,
            has_dropdown: true,
            form_main_section_id: row.id,
          }));

          if (!Array.isArray(this.visible_tabs)) {
            this.visible_tabs = [];
          }

          const insert_after_index = this.visible_tabs.findIndex(
            (tab) => tab.id === "application_data"
          );

          if (insert_after_index !== -1) {
            this.visible_tabs.splice(insert_after_index + 1, 0, ...dynamic_tabs);
          } else {
            this.visible_tabs.push(...dynamic_tabs);
          }

          this.database_tabs = dynamic_tabs;

          if (
            typeof this.dropdown_options !== "object" ||
            this.dropdown_options === null
          ) {
            this.dropdown_options = {};
          }

          dynamic_tabs.forEach((tab) => {
            const options = [{ value: tab.id, label: tab.name }];
            if (this.$set) {
              this.$set(this.dropdown_options, tab.id, options);
            } else {
              this.dropdown_options[tab.id] = options;
            }
          });
        })
        .catch((error) => {
          const message =
            error?.response?.data?.message ||
            error.message ||
            "Failed to load tabs";
          this.show_error(message);
        });
    },

    select_admin(admin_name) {
      this.temp_selected = admin_name;
      this.assign_trust_admin();
    },

    get_form_dropdown_value() {
      const mapping = {
        'trust_information': 'trust information',
      };
      return mapping[this.active_tab];
    },

    initializeTabs() {
      const storage_key = `active_tab_${this.application_id}`;
      const saved_tab = localStorage.getItem(storage_key);

      if (saved_tab === undefined || saved_tab === null) {
        this.visible_tabs = [...this.all_tabs];
        if (this.visible_tabs.length > 0) {
          this.select_tab(this.visible_tabs[0].id);
        }
      } else {
        this.select_tab(saved_tab);
      }
    },

    dropdown_forms_id(val) {
      if (!this.is_db_main_section_tab(val)) return null;
      const num = Number(String(val).slice(3));
      return Number.isFinite(num) ? num : null;
    },

    select_tab(tab_id) {
      this.active_tab = tab_id;

      const storage_key = `active_tab_${this.application_id}`;
      localStorage.setItem(storage_key, tab_id);

      if (this.is_db_main_section_tab(tab_id)) {
        if (!this.dropdown_options[tab_id]) {
          this.dropdown_options[tab_id] = [{ value: tab_id, label: this.get_db_tab_label(tab_id) }];
        }
        const t = this.visible_tabs.find(t => t.id === tab_id);
        if (t && !t.has_dropdown) t.has_dropdown = true;

        this.selected_dropdown = tab_id;
        this.active_form_main_section_id = this.dropdown_forms_id(tab_id);
        return;
      }

      const forms_dropdown_value = this.get_form_dropdown_value();
      if (forms_dropdown_value) {
        this.selected_dropdown = forms_dropdown_value;
      } else if (this.active_tab_has_dropdown) {
        const options = this.dropdown_options[tab_id];
        this.selected_dropdown = options?.[0]?.value || null;
      } else {
        this.selected_dropdown = null;
      }

      this.active_form_main_section_id = null;
    },

    admin_verify(status) {
      const data = {
        application_id: parseInt(this.application_id, 10),
        status: status
      };

      axios.post(ADMIN_VERIFY_APPLICATION_URL, data, {
        headers: this.headers
      })
        .then(response => {
          const response_data = response.data;

          if (response_data.status === 'success') {
            sessionStorage.setItem('application_status', response_data.data)
            this.application_status = this.format_question_type(response_data.data)
            this.get_form_to_preview();
            this.show_success("Admin verified successfully.")
          } else {
            this.show_error('Error during the admin verification');
          }
        })
        .catch(error => {
          if (error.response && error.response.data) {
            this.show_error(error.response.data.message);
          }
        });
      this.show_success('Answers approved successfully');
    },

    get_db_tab_label(tab_id) {
      const tab =
        (Array.isArray(this.visible_tabs) ? this.visible_tabs : []).find(t => t.id === tab_id) ||
        (Array.isArray(this.database_tabs) ? this.database_tabs : []).find(t => t.id === tab_id);

      if (tab?.name) return tab.name;
      const id_num = this.dropdown_forms_id(tab_id);
      return id_num != null ? `Section ${id_num}` : 'Section';
    },

    clear_admin_data() {
      this.assigned_admin = null;
      this.selected_admin = '';
      this.temp_selected = '';
    },

    async assign_trust_admin() {
      const selected_admin_obj = this.users.find(
        user => `${user.first_name} ${user.last_name}` === this.temp_selected
      );

      if (!selected_admin_obj) {
        const error = new Error('Selected admin not found');
        this.show_error(error);
      }

      const payload = {
        application_id: Number(this.application_id),
        user_id: Number(selected_admin_obj.user_id),
        assign_as_administrator: true
      };

      return axios.post(ASSIGN_TRUST_ADMIN, payload, {
        headers: this.headers
      })
        .then(async (response) => {
          if (response.data.status === 'success') {
            this.selected_admin = this.temp_selected;
            this.show_dropdown = false;

            this.show_success(response.data.message || 'Admin assigned successfully');
            return response.data;
          } else {
            const error = new Error(response.data.message || 'Failed to assign admin');
            this.show_error(error);
          }
        })
        .catch((error) => {
          this.show_error(error.response?.data?.message || error.message || 'Failed to assign admin');
        });
    },

    assign_admin() {
      this.assign_trust_admin();
    },

    toggle_dropdown(value) {
      this.selected_dropdown = this.selected_dropdown === value ? '' : value;
    },

    async fetch_users() {
      this.error_message = '';
      try {
        const response = await axios.get(USER_LIST_URLS, {
          headers: this.headers,
          params: { project_id: this.project_id }
        });

        const res = JSON.parse(response.data);

        this.users = res.data.map(user => ({
          user_id: user.user_id,
          first_name: user.user.first_name,
          last_name: user.user.last_name,
          name: (user.user.first_name && user.user.last_name)
            ? `${user.user.first_name} ${user.user.last_name}`
            : "User has not logged in",
          email: user.user.email,
          phone_number: user.phone_number || '',
          last_login: user.user?.last_login ?? "Never logged in",
          role: user.user.role.role === "Entity" ? "Founder" : user.user.role.role,
          is_active: user.is_active,
          rawRole: user.user.role.role
        }));

        this.system_admins = this.users
          .filter(user => user.rawRole === "System Admin")
          .map(admin => admin.name);

        this.users_list = this.users;
        this.table_headers = Object.keys(this.users_list[0]);
      } catch (error) {
        this.error_message = 'Error fetching users: ' + error.message;
        this.show_error(this.error_message);
      }
    },

    async fetch_roles() {
      const response = await axios.get(ROLES_URL, {
        headers: this.headers,
      });
      this.user_roles = response.data.data;
    },

    handle_verification_start() {
      this.is_verifying = true;
      setTimeout(() => {
        this.is_verifying = false;
        this.show_success('Verification completed successfully');
      }, 3000);
    },

    handle_error(error) {
      this.is_verifying = false;
      this.show_error('Verification failed: ' + error.message);
    },

    async refresh_hierarchy() {
      await this.refresh_hierarchy();
    }
  },
  created() {
    this.headers = get_headers();

    const storage_key = `active_tab_${this.application_id}`;
    const saved_tab = localStorage.getItem(storage_key);

    if (saved_tab) {
      this.active_tab = saved_tab;
    } else if (this.visible_tabs.length > 0) {
      this.active_tab = this.visible_tabs[0].id;
    }

    this.project_id = get_project_id()
    this.update_data_from_route();
    const query = this.$route.query;
    this.form_id = query.form_id || null;
    this.role_id = query.role_id || null;
    this.profile_role_id = query.profile_role_form_id || null;
    this.user_id = query.user_id;
  },
  async mounted() {
    const loader = await this.show_loader("Loading application overview...");

    try {
      this.user_role = get_user_role();
      const storage_key = `active_tab_${this.application_id}`;
      const saved_tab = localStorage.getItem(storage_key);
      this.initializeTabs();

      await this.fetch_users();
      await this.fetch_roles();
      await this.fetch_assigned_widgets();
      await this.fetch_main_section_tabs();
      await this.load_full_hierarchy();
      if (this.visible_tabs.length > 0) {
        if (saved_tab === null || saved_tab === undefined) {
          this.select_tab(this.visible_tabs[0].id);
        } else {
          this.select_tab(saved_tab);
        }
      }
    } catch (error) {
      this.show_error('Error loading application data: ' + error.message);
    } finally {
      this.close_loader(loader);
    }
  },
  
  beforeDestroy() {
    // Clean up modal event listeners if any
    const modalElement = document.getElementById('assign_sub_entity_modal');
    if (modalElement) {
      const modal = bootstrap.Modal.getInstance(modalElement);
      if (modal) {
        modal.dispose();
      }
    }
  }
};